var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isExpired
    ? _c("a", {
        staticClass: "union-activity",
        style: {
          backgroundImage: "url(" + _vm.unionActivity + ")"
        },
        attrs: {
          target: "_blank",
          href: "/static/html/joint_product/index.html"
        },
        on: { click: _vm.bannerClick }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }